export default {
      id: "oc-alipay-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-alipay",
      toString: function () {
        return this.url;
      }
    }